import { useState } from "react"
import { useNavigate, useSearchParams, useLocation } from "react-router-dom"

import Style from "./style"

import MainHeader from "widget/MainHeader"
import Pagenation from "widget/Pagenation"

import useGetExamList from "entity/exam/useGetExamList"

import TStyle from "shared/style/tableStyle"
import timestampCalculator from "shared/lib/timestampCalculator"

const TryoutExamList = () => {
    const navigate = useNavigate()
    const [searchParams, setSearchParams] = useSearchParams()
    const proGrade = searchParams.get("proGrade")

    const [examList] = useGetExamList()

    const tabList = ["rookie", "semi", "tour"]
    const sizeList = ["short", "medium", "expand", "long"]
    const tableHeadList = ["IDX", "버전", "현재 출력 중인 버전", "생성 날짜"]

    const clickTabEvent = (value) => {
        searchParams.set("proGrade", value)
        setSearchParams(searchParams)
    }

    return (
        <Style.Wrapper>
            <MainHeader>트라이아웃 필기 시험 목록</MainHeader>

            <Style.TabDiv>
                {tabList.map(elem => <Style.Tab $selected={proGrade === elem} onClick={() => clickTabEvent(elem)}>{elem}</Style.Tab>)}
            </Style.TabDiv>

            <TStyle.TableDiv>
                <TStyle.TableRow $title>
                    {tableHeadList.map((elem, index) =>
                        <TStyle.Data $title $size={sizeList[index]}>{elem}</TStyle.Data>
                    )}
                </TStyle.TableRow>
                {examList?.data?.exam_list?.map((elem, index) =>
                    <TStyle.TableRow $odd={index % 2 === 1} onClick={() => navigate(`/exam/${elem?.idx}/detail`)}>
                        <TStyle.Data $size={sizeList[0]}>{elem?.idx}</TStyle.Data>
                        <TStyle.Data $size={sizeList[1]}>회차 {elem?.version}</TStyle.Data>
                        <TStyle.Data $size={sizeList[2]}>{index === 0 ? "Yes" : ""}</TStyle.Data>
                        <TStyle.Data $size={sizeList[3]}>{timestampCalculator(elem?.created_at)}</TStyle.Data>
                    </TStyle.TableRow>
                )}
            </TStyle.TableDiv>

            <Pagenation maxPage={examList?.data?.max_page} />

        </Style.Wrapper>
    )
}

export default TryoutExamList